import React, { useEffect, useMemo, useState } from "react";
import { Box, Chip, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { CART_EDIT_TABLE_HEAD } from "../../components/datagrid/Cartedit/CartEditTableHead";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import ActionDetails from "../../components/mui/GlobalAnchor/ActionDetails";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { getCartEditRequests } from "../../redux/features/generalSlice";
import GlobalAnchorList from "../../components/mui/GlobalAnchor/GlobalAnchorList";
import DeleteEditrequest from "./DeleteRequest";
import CartEditRequest from "./CartEditRequest";
import FinanceApproval from "./FinanceApproval";
import SOGOApproval from "./SOGOApproval";
import CartItemEdit from "../ogd/myworkspace/Cart/CartEdit/CartItemEdit";
import FinanceLogView from "./FinanceLogView";
import { getSubjects, getClasses } from "../../redux/features/croSlice";

const CartEditView = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const { loading, cartEditRequests } = useSelector((state) => state.general);

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
  };
  const profile = JSON.parse(localStorage.getItem("cred")).profile;

  useEffect(() => {
    dispatch(getSubjects());
    dispatch(getClasses());
  }, []);
  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getCartEditRequests(data));
    }
  }, [pageNum, gridSize, search]);

  const columns = useMemo(() => {
    let baseColumns = [...CART_EDIT_TABLE_HEAD];

    if (profile.departmentId !== 7) {
      baseColumns.push({
        field: "EditCartData",
        headerName: "Edit Cart Data",
        width: 200,
        disableClickEventBubbling: true,
        renderCell: (params) => (
          <CartItemEdit dispatchParams={data} row={params.row} />
        ),
      });
    }

    return baseColumns;
  }, [CART_EDIT_TABLE_HEAD, data, profile.departmentId]);

  return (
    <GlobalWrapper title={"Cart Edit Requests"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={cartEditRequests?.data}
          meta={cartEditRequests?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="request_id"
          rowClick={true}
          actionComponent={
            <>
              {rowData && (
                <>
                  {" "}
                  <ActionDetails val={rowData?.request_title} />
                  {rowData &&
                  profile.role === "Senior Operations Growth Officer" ? (
                    <GlobalAnchorList
                      label="SOGO Status"
                      component={
                        <SOGOApproval
                          row={rowData}
                          dispatchParams={data}
                          requestId={rowData?.request_id}
                        />
                      }
                    />
                  ) : null}
                  {profile.departmentId === 7 ? (
                    <GlobalAnchorList
                      label="Finance Approval"
                      component={
                        <FinanceApproval
                          row={rowData}
                          dispatchParams={data}
                          requestId={rowData?.request_id}
                        />
                      }
                    />
                  ) : null}
                  <GlobalAnchorList
                    label="Delete Request"
                    component={
                      <DeleteEditrequest
                        row={rowData}
                        dispatchParams={data}
                        requestId={rowData?.request_id}
                      />
                    }
                  />
                  <GlobalAnchorList
                    component={
                      <CartEditRequest
                        courseenrollmentId={rowData?.course_enrollment_id}
                        dispatchdata={data}
                        row={rowData}
                      />
                    }
                    label={"Update Request"}
                  />
                  {profile.departmentId === 7 ? (
                    <GlobalAnchorList
                      component={
                        <FinanceLogView requestID={rowData?.request_id} />
                      }
                      label={"Log View"}
                    />
                  ) : null}
                </>
              )}
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default CartEditView;
